export default "__VITE_ASSET__DuRf4vPb__"